<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="col-lg-3">
      </div>
    </div>
    <div class="col-lg-12">
      <button class="btn btn-primary btn-xs" @click="showAddLink = true"><i class="fa fa-plus"></i> Add</button>
      <table class="table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th>GEO</th>
            <th>Website</th>
            <th>Bonus Text</th>
            <th>Affiliate Link</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="showAddLink">
            <td>
              <v-select :options="selectedCountries" v-model="newLink.country" index="country_iso_code" label="location_name" placeholder="Country"></v-select>
            </td>
            <td>
            </td>
            <td>
              <input type="text" v-model="newLink.bonusText" class="form-control" >
            </td>
            <td>
              <input type="text" v-model="newLink.affiliateLink" class="form-control">
            </td>
            <td>
              <button class="btn btn-primary btn-sm" @click="editLink(newLink)"><i class="fa fa-save"></i> Save</button>
              <button class="btn btn-danger btn-sm" @click="showAddLink = false; $forceUpdate()"><i class="fa fa-remove"></i> Cancel</button>
            </td>
          </tr>
          <template v-for="country in brand.countries">
            <tr v-for="(link) in country.affiliateLinks" :key="link.id">
              <td>{{ getCountryName(country.countryCode) }}</td>
              <td>{{ link.website }}</td>
              <td v-if="!editing[link.id]">{{ link.bonusText }}</td>
              <td v-else><input type="text" v-model="link.bonusText" class="form-control"></td>
              <td v-if="!editing[link.id]">{{ link.affiliateLink }}</td>
              <td v-else><input type="text" v-model="link.affiliateLink" class="form-control"></td>
              <td v-if="!editing[link.id]">
                <i class="fa fa-edit pointer" v-tooltip="'Edit Link'" @click="editing[link.id] = true; $forceUpdate()"></i>
                <i class="fa fa-remove pointer" v-tooltip="'Delete Link'" @click="deleteLink(link.id)"></i>
              </td>
              <td v-else>
                <button class="btn btn-primary btn-sm" @click="editLink(link,country.countryCode)"><i class="fa fa-save"></i> Save</button>
                <button class="btn btn-danger btn-sm" @click="editing[link.id] = false; $forceUpdate()"><i class="fa fa-remove"></i> Cancel</button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import countryMixin from '../../../../../mixins/countryMixin'
import { BRAND_SET } from '../../../../../store/mutation-types'

export default {
  data () {
    return {
      affLinks: [],
      newLink: {},
      showAddLink: false,
      editing: {}
    }
  },
  computed: {
    ...mapGetters({
      brand: 'getBrand'
    }),
    selectedCountries () {
      return this.brand.countries.map(country => ({
        country_iso_code: country.countryCode,
        location_name: this.getCountryName(country.countryCode)
      }))
    }
  },
  mixins: [countryMixin],
  mounted () {
    this.getLinks()
  },
  methods: {
    async getLinks () {
      try {
        let resp = await axios.get(`/advertisers/brands/${this.brand.id}`)
        this.$store.commit(BRAND_SET, resp.data)
      } catch (error) {
        this.$toastr.error('Failed loading brand', error)
      }
    },
    async editLink (link, country) {
      try {
        if (link.id) {
          await axios.put(`/advertisers/brands/${this.brand.id}/link/${link.id}`, {
            bonusText: link.bonusText,
            affiliateLink: link.affiliateLink
          })
        } else {
          await axios.post(`/advertisers/brands/${this.brand.id}/link/`, {
            country: link.country,
            bonusText: link.bonusText,
            affiliateLink: link.affiliateLink
          })
        }
        this.newLink = {}
        this.showAddLink = false
        this.editing = {}
        await this.getLinks()
      } catch (e) {
        this.$toastr.error(e)
      }
    },
    async deleteLink (linkID) {
      try {
        await axios.delete(`/advertisers/brands/${this.brand.id}/link/${linkID}`)
        this.$toastr.success('Link deleted successfully')
        this.getLinks()
      } catch (error) {
        this.$toastr.error('Failed deleting link', error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/Brand/Tabs/Afflinks.vue